module.exports = __webpack_public_path__ + "static/media/info-description.14e5c9ab.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-description.gif
// module id = 1746
// module chunks = 0